import React, { useState, useCallback, useEffect } from 'react';
import { roles } from '../../Constants';
import useApi from '../../api/useApi';

function CreateEditUser({ handleClose, notification, action, selectedUser, refreshList }) {
  const orgId = JSON.parse(localStorage.user).organization.id;
  const { userId } = JSON.parse(localStorage.user).user;
  const formModel = {
    userName: '',
    slug: '',
    email: '',
    contact: '',
    avatar: '',
    organizationId: orgId,
    role: '0',
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {}, [formData]);

  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/user/${selectedUser}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (action === 'create') postData('/user', 'POST', formData);
    else updateData(`/user/${selectedUser}`, 'PATCH', formData);
  };

  //create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', 'User created successfully');
      refreshList();
      // handleClose();
    }

    if (isError) {
      notification('error', 'Unable to create user');
      handleClose();
    }
  }, [isLoading, isError, data]);

  //getUser for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setFormData(state.data.user);
    }

    if (state.isError) {
      notification('error', 'Unable to fetch user detail');
    }
  }, [state]);

  //update response
  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data !== null) {
      notification('success', 'User updated successfully');
      refreshList();
    }
    if (state2.isError) {
      notification('error', 'Unable to update user detail');
    }
    // refreshList();
  }, [state2]);

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20 px-16"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white h-3/5 w-3/4 py-12 px-16 rounded-3xl relative mt-10">
        <img
          src="assets/img/Close.svg"
          className="absolute top-5 right-10 h-4 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-lg text-textBlue1">{action === 'create' ? 'Create' : 'Edit'} a User</p>

        <form className="mt-10 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="userName" className="block text-parameter w-1/3 text-sm">
              NAME
            </label>
            <input
              type="text"
              value={formData.userName}
              autoComplete="off"
              name="userName"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div>

          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="slug" className="block text-parameter w-1/3 text-sm">
              SHORT NAME
            </label>
            <input
              type="text"
              value={formData.slug}
              autoComplete="off"
              name="slug"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div>

          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="email" className="block text-parameter w-1/3 text-sm">
              EMAIL
            </label>
            <input
              type="email"
              value={formData.email}
              name="email"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div>

          <div className="flex w-1/2 items-center  my-3.5">
            <label htmlFor="contact" className="block text-parameter w-1/3 text-sm">
              PHONE NUMBER
            </label>
            <input
              type="tel"
              value={formData.contact}
              name="contact"
              autoComplete="off"
              className="rounded-lg bg-white px-4 py-3 focus:outline-none  text-parameter border w-1/2 h-10"
              onChange={handleInputChange}
            />
          </div>

          <div className="flex w-1/2 items-center my-3.5">
            <label htmlFor="role" className="block text-parameter w-1/3 text-sm">
              ROLE
            </label>

            <div className="rounded-lg bg-white px-2 py-3 focus:outline-none text-sm  text-parameter border w-1/2 h-10">
              <select
                name="role"
                value={formData.role}
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                {roles.map((item) => (
                  <option key={item.id} value={item.id} className="fy-4">
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex w-1/2 items-center  my-3.5 relative">
            <label className="block text-parameter w-1/3 text-sm" />
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
            ) : (
              <input
                type="submit"
                className="rounded-lg focus:outline-none w-1/2 h-10 text-textBlue1 cursor-pointer "
                style={{ background: '#16406D33', border: '1px solid #16406D' }}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateEditUser;
